(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.headerIsAlwaysSticky) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var picker = document.querySelector('[data-tr-plan-picker]');
    var form = document.querySelector('[data-tr-checkout-form]');
    if (!picker || !form) return;

    var variantInput = form.querySelector('[data-tr-variant-input]');
    var planInput = form.querySelector('[data-tr-selling-plan-input]');
    var submitButton = form.querySelector('button[type="submit"]');

    // Purchase-option toggle: each card represents a (variant + selling plan)
    // tuple. Toggling syncs both hidden inputs and the selected-card class.
    picker.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || target.name !== 'tr-purchase-option') return;

      var variantId = target.getAttribute('data-variant-id');
      var planId = target.getAttribute('data-plan-id') || '';

      if (variantInput) variantInput.value = variantId;
      if (planInput) planInput.value = planId;

      var cards = picker.querySelectorAll('.tr-plan-card');
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-variant-id') === variantId) {
          cards[i].classList.add('tr-plan-card--selected');
        } else {
          cards[i].classList.remove('tr-plan-card--selected');
        }
      }
    });

    // Subscribe submit: clear cart, add the selected (variant + plan), then
    // redirect to checkout. Idempotent — clicking multiple times never stacks
    // quantity, and a returning visitor always lands at checkout with exactly
    // 1 of the currently selected option.
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (submitButton) {
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.setAttribute('aria-busy', 'true');
      }

      var variantId = variantInput ? variantInput.value : null;
      var planId = planInput ? planInput.value : '';

      if (!variantId) {
        if (submitButton) submitButton.removeAttribute('disabled');
        return;
      }

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
        .then(function () {
          var body = new FormData();
          body.append('id', variantId);
          body.append('quantity', '1');
          if (planId) body.append('selling_plan', planId);
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: body
          });
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || 'Add to cart failed');
            });
          }
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('Subscribe error:', err);
          if (submitButton) {
            submitButton.removeAttribute('disabled');
            submitButton.removeAttribute('aria-busy');
          }
          // Last-resort fallback: native form submit.
          form.submit();
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tr-video"] && !Shopify.designMode) return;
  try {
    
  class TrVideoPlayer extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.tr-video__play-btn');
      if (this.button && this.video) {
        this.button.addEventListener('click', () => this.play());
      }
    }

    play() {
      if (!this.video) return;
      this.video.controls = true;
      this.video.play();
      this.classList.add('is-playing');
    }
  }

  if (!customElements.get('tr-video-player')) {
    customElements.define('tr-video-player', TrVideoPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
